/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowSubsystemResult } from './ShadowSubsystemResult';
import {
    ShadowSubsystemResultFromJSON,
    ShadowSubsystemResultFromJSONTyped,
    ShadowSubsystemResultToJSON,
} from './ShadowSubsystemResult';

/**
 * The five backend subsystems as written by the shadow auto-decisioning
 * processor. The FE is responsible for mapping these onto its UI sub-tabs
 * (e.g. background = safety + administrative, admission_package =
 * clinical + medication rows, etc.).
 * 
 * @export
 * @interface ShadowSubsystemResults
 */
export interface ShadowSubsystemResults {
    /**
     * 
     * @type {ShadowSubsystemResult}
     * @memberof ShadowSubsystemResults
     */
    clinical: ShadowSubsystemResult;
    /**
     * 
     * @type {ShadowSubsystemResult}
     * @memberof ShadowSubsystemResults
     */
    financial: ShadowSubsystemResult;
    /**
     * 
     * @type {ShadowSubsystemResult}
     * @memberof ShadowSubsystemResults
     */
    safety: ShadowSubsystemResult;
    /**
     * 
     * @type {ShadowSubsystemResult}
     * @memberof ShadowSubsystemResults
     */
    administrative: ShadowSubsystemResult;
    /**
     * 
     * @type {ShadowSubsystemResult}
     * @memberof ShadowSubsystemResults
     */
    occupancy: ShadowSubsystemResult;
}

/**
 * Check if a given object implements the ShadowSubsystemResults interface.
 */
export function instanceOfShadowSubsystemResults(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clinical" in value;
    isInstance = isInstance && "financial" in value;
    isInstance = isInstance && "safety" in value;
    isInstance = isInstance && "administrative" in value;
    isInstance = isInstance && "occupancy" in value;

    return isInstance;
}

export function ShadowSubsystemResultsFromJSON(json: any): ShadowSubsystemResults {
    return ShadowSubsystemResultsFromJSONTyped(json, false);
}

export function ShadowSubsystemResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clinical': ShadowSubsystemResultFromJSON(json['clinical']),
        'financial': ShadowSubsystemResultFromJSON(json['financial']),
        'safety': ShadowSubsystemResultFromJSON(json['safety']),
        'administrative': ShadowSubsystemResultFromJSON(json['administrative']),
        'occupancy': ShadowSubsystemResultFromJSON(json['occupancy']),
    };
}

export function ShadowSubsystemResultsToJSON(value?: ShadowSubsystemResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clinical': ShadowSubsystemResultToJSON(value.clinical),
        'financial': ShadowSubsystemResultToJSON(value.financial),
        'safety': ShadowSubsystemResultToJSON(value.safety),
        'administrative': ShadowSubsystemResultToJSON(value.administrative),
        'occupancy': ShadowSubsystemResultToJSON(value.occupancy),
    };
}

